<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <el-form :model="formInline"
                   class="demo-form-inline">
            <el-col :span="8">
              <el-form-item label="企业名称：">
                <el-select v-model="formInline.customername"
                           filterable
                           clearable
                           placeholder="请选择">
                  <el-option v-for="item in clientNames"
                             :key="item.clientId"
                             :label="item.clientName"
                             :value="item.clientName">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="区域：">
                <el-select v-model="formInline.provinceName"
                           filterable
                           clearable
                           placeholder="请选择区域">
                  <el-option v-for="item in provinces"
                             :key="item.code"
                             :label="item.name"
                             :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户状态：">
                <el-select v-model="formInline.customerStatus"
                           clearable
                           placeholder="全部">
                  <el-option label="已绑定"
                             :value="1"></el-option>
                  <el-option label="未绑定"
                             :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户重要等级：">
                <el-select v-model="formInline.clientLevel">
                  <el-option label="一般"
                             :value="1"></el-option>
                  <el-option label="重要"
                             :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户电压等级：">
                <el-select v-model="formInline.clientEleLevel"
                           clearable
                           placeholder="请选择电压等级">
                  <el-option label="不满1kV"
                             value="1"></el-option>
                  <el-option label="1-10kV"
                             value="2"></el-option>
                  <el-option label="35kV"
                             value="3"></el-option>
                  <el-option label="11kV"
                             value="4"></el-option>
                  <el-option label="110kV"
                             value="5"></el-option>
                  <el-option label="220kV及以上"
                             value="6"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="销售负责人：">
                <el-input v-model="formInline.salesmanname"
                          placeholder=""></el-input>
                <!-- <el-select v-model="formInline.salesmanname"
                           clearable
                           placeholder="请选择销售负责人">
                  <el-option v-for="item in username"
                             :key="item.userId"
                             :label="item.username"
                             :value="item.username">
                  </el-option>
                </el-select> -->

                <el-button type="primary"
                           style="margin-left:20px"
                           @click="current=1;onSubmit()">查询</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <div>
        <div style="background-color: rgba(243, 243, 243, 1);padding-top:20px">
          <el-row style="padding:0 20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"
                   style="margin-right:10px"></i>客户列表</p>
            </el-col>
            <el-col :span="12"
                    style="justify-content: flex-end;display:flex">
              <el-upload class="upload-demo"
                         action
                         v-if="show('import')"
                         :show-file-list="false"
                         :http-request="uploadfile">
                <el-button size="small"
                           type="primary">导入</el-button>
              </el-upload>
              <el-button type="primary"
                         style="margin-left:20px"
                         size="mini"
                         v-if="show('export')"
                         @click="exportMethod('https://c.cesc-energy.com/service/client/export','客户列表.xlsx')">导出数据</el-button>
                           <el-button type="primary"
                         style="margin-left:20px"
                         size="mini"
                         v-if="show('exportT')"
                         @click="exportMethod('https://c.cesc-energy.com/service/client/export/template','客户列表.xlsx')">导出模板</el-button>
              <el-button type="primary"
                         v-if="show('add')"
                         style="margin-left:20px"
                         @click="add"
                         size="mini">新增客户</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <div style="overflow:auto">
                <el-table border
                          ref="multipleTable"
                          :data="tableData"
                          tooltip-effect="dark"
                          @selection-change="handleSelectionChange">
                  <el-table-column type="selection">
                  </el-table-column>
                  <el-table-column label="区域"
                                   width="100">
                    <template slot-scope="scope">{{ scope.row.provinceName}}</template>
                  </el-table-column>
                  <el-table-column prop="customername"
                                   label="企业名称">
                  </el-table-column>
                  <el-table-column prop="signDate"
                                   sortable
                                   label="签约日期">
                  </el-table-column>
                  <el-table-column prop="salesmanname"
                                   label="销售负责人">
                  </el-table-column>
                  <el-table-column prop="salesmanPhoneNumber"
                                   label="联系方式">
                  </el-table-column>
                  <el-table-column prop="clientLevel"
                                   label="客户重要等级">
                    <template slot-scope="scope">{{ scope.row.clientLevel==1?'一般':'重要'}}</template>
                  </el-table-column>
                  <el-table-column prop="clientEleLevel"
                                   label="客户电压等级">
                    <template slot-scope="scope">
                      <span v-show="scope.row.clientEleLevel==1">不满1kV</span>
                      <span v-show="scope.row.clientEleLevel==2">1-10kV</span>
                      <span v-show="scope.row.clientEleLevel==3">35kV</span>
                      <span v-show="scope.row.clientEleLevel==4">11kV</span>
                      <span v-show="scope.row.clientEleLevel==5">110kV</span>
                      <span v-show="scope.row.clientEleLevel==6">220kV及以上</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="accountNumber"
                                   label="户号数量">
                  </el-table-column>
                  <el-table-column prop="agentPrincipal"
                                   label="代理负责人">
                  </el-table-column>
                  <el-table-column prop="customerStatus"
                                   label="客户状态">
                    <template slot-scope="scope">
                      <span v-show="scope.row.customerStatus==1">已绑定</span>
                      <span v-show="scope.row.customerStatus==0">未绑定</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address"
                                   label="操作"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button @click="check(scope.row)"
                                 v-if="show('see')"
                                 type="text"
                                 size="small">查看</el-button>
                      <el-button @click="check1(scope.row.id)"
                                 type="text"
                                 v-if="show('edit')"
                                 size="small">编辑</el-button>
                      <el-button type="text"
                                 size="small"
                                 v-if="show('delete')"
                                 @click="deleteTable(scope.$index, tableData,scope.row.id)">删除</el-button>

                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-top: 20px;padding:20px">
                <el-checkbox v-model="checked"
                             @change="toggleAllSelection">全选</el-checkbox>
                <el-select v-model="value"
                           style="margin:0 10px"
                           placeholder="批量操作">
                  <el-option label="删除"
                             value="1">
                  </el-option>
                </el-select>
                <el-button @click="deleteTables"
                           type="danger">确定</el-button>
                <div class="pagination">
                  <el-pagination @current-change="handleCurrentChange"
                                 :current-page="current"
                                 :page-size="10"
                                 background
                                 layout="total, prev, pager, next, jumper"
                                 :total="total">
                  </el-pagination>
                </div>
              </div>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getClientPage, deleteClientInfo, deletesClientInfo, postreadfile, getmenusubmenu, getclientNames, getprovince, getUserNames } from '../../API'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      formInline: {},
      checked: false,
      total: 0,
      current: 1,
      tableData: [],
      value: '1',
      multipleSelection: [],
      menuList: [],
      clientNames: [],
      provinces: [],
      username: []
    }
  },
  created () {
    getClientPage().then(res => {
      if (res.code === 0) {
        this.total = res.data.total;
        this.current = res.data.current;
        this.tableData = res.data.records
      }
    })
    getUserNames().then(res => {
      if (res.code === 0) {

        this.username = res.data
      }
    })
    getmenusubmenu(localStorage.getItem('parentId')).then(res => {
      if (res.code === 0) {
        this.menuList = res.data
      }
    })
    getclientNames().then(res => {
      if (res.code === 0) {
        this.clientNames = res.data
      }
    })
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinces = res.data
      }
    })
  },
  methods: {
    exportMethod,
    show (k) {
      for (let i = 0; i < this.menuList.length; i++) {
        if (k == this.menuList[i].permission) {
          return true
        }
        else {

        }
      }
    },
    uploadfile (item) {
      let fileObj = item.file
      let name = fileObj.name;
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        return false;
      }
      const form = new FormData()// FormData 对象
      form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
      postreadfile(form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
      })
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deleteClientInfo(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getClientPage().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteTables () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].id)
        }
        deletesClientInfo(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getClientPage().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit () {
      let params = this.formInline
      params.current = this.current
      getClientPage(params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
    check1 (id) {
      this.$router.push({ path: '/CustomerManagement/khzlxg', query: { text: '修改客户资料', } })
      localStorage.setItem("id", id)
    },
    handleCurrentChange (val) {
      this.current = val
      this.onSubmit()
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    check (row) {
      this.$router.push({ path: '/CustomerManagement/CustomerInformation', query: { id: row.id } })
      localStorage.setItem('id', row.id)
    }, add () {
      this.$router.push('/CustomerManagement/khzlxz')
      localStorage.removeItem('id')
    }
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
/deep/.el-input {
  width: 217px;
}
/deep/ .el-table {
  max-width: 200%;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
  /deep/ .el-input {
    width: 50px;
  }
}
</style>